import { useContext } from 'react'
import { CreatorPageContext } from '../contexts'

export const useCreatorPage = () => useContext(CreatorPageContext)
